SC.find_studio_classes = (function () {
  var api = {};

  var init = function () {
    var $findClassContainer = $('.find-class-container');

    if ($(window).width() <= 480) {
      mobileHandlers();
    }

    if ($findClassContainer.data('new-rider')) {
      displayStudioCalendarProTip();
    }
  };

  var mobileHandlers = function () {
    $('.session .bookmark').click(function () {

    });
  };

  // NOT TODAY. display monday classes by default
  if ( !$('.classes-days .today').length ) {
    $('.column-day:first-child').css('display', 'block');
    $('.column-header:first-child .active-day').addClass('selected-day');
  }

  enquire.register('screen and (max-width:1024px)', {
    match: function () {
      $(window).on('popstate', function () {
        $('.column-header .active-day').removeClass('selected-day');
        var currentState = history.state;
        var day = currentState.page;
        // add black circle highlight to selected day
        var $activeDay = $(".column-day[ data-date='" + day +  "' ]");
        $(".column-header[ data-date='" + day + "' ]").children('.active-day').addClass('selected-day');
        // hide previously displayed day classes
        $('.column-day').hide();
        // show selected day classes
        $activeDay.show();
      });

      if (history.state) {
        $('.column-header .active-day').removeClass('selected-day');
        var currentState = history.state;
        var day = currentState.page;
        // add black circle highlight to selected day
        var $activeDay = $(".column-day[ data-date='" + day +  "' ]");
        $(".column-header[ data-date='" + day + "' ]").children('.active-day').addClass('selected-day');
        // hide previously displayed day classes
        $('.column-day').hide();
        // show selected day classes
        $activeDay.show();
      }

      $('.next-week-small, .prev-week-small').on('click', function (e) {
        e.preventDefault();
        var date = $('.selected-day').children('.date').text();
        history.replaceState({page: date}, 'current-day', '?page=' + date);
        window.location.href = $(this).attr('href');
      });
    },

    unmatch: function () {
      $(window).off('popstate');
      $('.next-week-small, .prev-week-small').off('click');
    }
  });

  // update small nav copy
  var weekStart = $('.week-info').data('week-start');
  var weekEnd = $('.week-info').data('week-end');
  var today = new Date();

  if (dateCheck(weekStart, weekEnd, today)) {
    $('.week-info').addClass('visible');
  } else {
    $('.week-info').text(weekStart + ' — ' + weekEnd).addClass('visible');
    document.getElementById('days-of-week-container').setAttribute('aria-label', 'Week of ' + weekStart + ' to ' + weekEnd);
  }

  // click events for days of week ( mobile view )
  $('.column-header').click(function () {
    // remove black circle highlight from previously selected day
    $('.column-header .active-day').removeClass('selected-day');

    // add black circle highlight to selected day
    $(this).children('.active-day').addClass('selected-day');
    var date = $(this).data('date');
    if (history.state) {
      history.pushState({page: date}, 'current-day', '?page=' + date);
    } else {
      history.replaceState({page: date}, 'current-day', '?page=' + date);
    }
    // hide previously displayed day classes
    $('.column-day').hide();

    // show selected day classes
    date = $(this).data('date');
    $(".column-day[ data-date='" + date +  "' ]").show();

    $('html, body').animate({ scrollTop: 0 });
  });

  function dateCheck(from, to, check) {
    if ((Date.parse(check) <= Date.parse(to) && Date.parse(check) >= Date.parse(from))) {
      return true;
    }
    return false;
  }

  $(window).scroll(function () {
    // get height of studio-info-container
    var $scrollDistanceFromTop = $('.studio-info-container').outerHeight();

    // if auth/login is not open, then allow schedule days to fix to top of page (just below fixed nav)
    if ($(window).scrollTop() > $scrollDistanceFromTop && !$('.soul-container').hasClass('auth-open')) {
      $('.days-of-week-container').addClass('fix-days-of-week');
      $('.studio-title-watermark').addClass('active');
      $('.classes-week-cols').css('padding-top', '130px');
    } else {
      $('.days-of-week-container').removeClass('fix-days-of-week');
      $('.studio-title-watermark').removeClass('active');
      $('.classes-week-cols').css('padding-top', '0');
    }
  });


  $('.session.booking_passed a.reserve').click(function (e) {
    e.preventDefault();
    confirmation(undefined, 'SORRY, THE RESERVATION WINDOW CLOSES THIRTY MINUTES PRIOR TO THE CLASS!');
  });

  /**
   * Old GA sendEvent - Next Week Button Click on Studio Schedule page
   * Deprecated: Will be removed soon.
   *
   * category: find_a_class
   * event: 'next_week_click'
   */
  $('.next-week-small').on('click', function () {
    SC.analytics.ga.sendEvent('find_a_class', 'next_week_click');
  });

  /**
   * Function to setup the Pro Tip Modal on the Studio Calendar Page
   * @returns {void}
   */
  var displayStudioCalendarProTip = function () {
    return SC.utils.ui.displayProTipModal(
      'Dismiss',
      'Pro Tip:',
      'Hit reserve on one of the class cells to get started.'
    );
  };

  init();
  return api;
})();
